<template>
  <div
    class="
      tw-flex
      tw-justify-between
      tw-items-center
      tw-py-2
      tw-px-3
      tw-shadow-card
      tw-border
      tw-border-solid
      tw-border-sf-snow-dark
      tw-rounded-md
      tw-font-sans
      tw-text-sm
      tw-leading-5
      tw-text-sf-gray-dark
      tw-min-h-10
      tw-relative
    "
    :class="containerClasses"
  >
    <div
      v-if="uiState === UIState.LOADING"
      class="
        tw-absolute
        tw-inset-0
        tw-bg-gradient-to-r
        tw-bg-no-repeat
        tw-from-transparent
        tw-from-60%
        tw-via-[rgba(139,92,246,0.1)]
        tw-via-70%
        tw-via-[rgba(139,92,246,0.05)
        tw-via-80%
        tw-to-transparent
        tw-to-100%
        tw-h-full
        tw-w-full
        tw-bg-200%
        tw-animate-ai-loading
        tw-z-0
      "
    ></div>
    <span
      class="tw-inline-block tw-relative tw-z-0"
      :class="leftContainerClasses"
    >
      <slot name="left" />
    </span>
    <span
      class="
        tw-inline-flex
        tw-relative
        tw-justify-between
        tw-items-center
        tw-gap-2
        tw-z-0
      "
      :class="rightContainerClasses"
    >
      <slot name="right" />
    </span>
  </div>
</template>
<script lang="ts" setup>
import type { ColorVariantsType, UIStateType } from '@app/shared/constants'

import { computed } from 'vue'

import { ColorVariants, UIState } from '@app/shared/constants'

defineOptions({
  name: 'SfCardInline',
})

interface Props {
  uiState?: Extract<UIStateType, 'default' | 'loading'>
  variant?: ColorVariantsType
}

const props = withDefaults(defineProps<Props>(), {
  uiState: UIState.DEFAULT,
  variant: ColorVariants.DEFAULT,
})

const containerClasses = computed(() => {
  return {
    'tw-bg-white': props.variant === ColorVariants.DEFAULT,
    'tw-bg-sf-success-subtle-2': props.variant === ColorVariants.SUCCESS,
    'tw-bg-sf-danger-subtle-2': props.variant === ColorVariants.DANGER,
    'tw-bg-sf-primary-subtle': props.variant === ColorVariants.INFO,
    'tw-bg-sf-warning-subtle-2': props.variant === ColorVariants.WARNING,
    'tw-bg-sf-ai-subtle-1': props.variant === ColorVariants.AI,
  }
})

const leftContainerClasses = computed(() => {
  return {
    'tw-text-sf-gray-dark': props.variant === ColorVariants.DEFAULT,
    'tw-text-sf-success': props.variant === ColorVariants.SUCCESS,
    'tw-text-sf-danger-dark-1': props.variant === ColorVariants.DANGER,
    'tw-text-sf-primary-darker': props.variant === ColorVariants.INFO,
    'tw-text-sf-warning': props.variant === ColorVariants.WARNING,
    'tw-text-sf-ai-darker-1': props.variant === ColorVariants.AI,
    'tw-opacity-50': props.uiState === UIState.LOADING,
  }
})

const rightContainerClasses = computed(() => {
  return {
    'tw-opacity-50': props.uiState === UIState.LOADING,
  }
})
</script>
